export default __webpack_public_path__ + "static/media/slide_03.b6c1ac20.png";